<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">Declarations and
                <br>Notice
              </h1>
              <img
                src="../../../public/assets/images/notepad.png"
                class="title-section-img form-title-img ops-section-img"
                alt="background image"
              >
            </article>
            <p class="input-info text-center notice">
              <i class="fas fa-exclamation-triangle not-eligible notice-fas"></i>
              <span class="not-eligible-text notice-span text-uppercase">NOTICE TO APPLICANT</span>
            </p>
            <p
              class="notice-text"
            >If you are aware of any incident, fact, circumstance, act or omission that could reasonably result in a professional liability claim against you, you should immediately file a report with your current carrier.
              <br>This application forms a part of your policy, if issued.The undersigned, acting on behalf of all Applicants, declare that the statements set forth in this Application are true and correct and that thorough efforts were made to obtain requested information from each and every Applicant proposed for this insurance to facilitate the proper and accurate completion of this Application. The undersigned agree that the information provided in this Application and any material submitted herewith are the representations of all the Applicants and are the basis for issuance of the insurance policy provided by us. Any material submitted with the Application shall be maintained on file (either electronically or paper) with us.
            </p>
            <p class="further mb-30">It is further agreed that:</p>
            <ul class="list-reset notice-list">
              <li class="flex">
                <i class="fas fa-check"></i>
                If any of the Applicants discover or become aware of any significant change in the condition of the Applicant's Organization between the date of this Application and the policy inception date, which would render the Application inaccurate or incomplete, notice of such change will be reported in writing to us immediately;
              </li>
              <li>
                <i class="fas fa-check"></i>
                Any policy issued, will be in reliance upon the truthfulness of the information provided in this Application; provided, however, with respect to such information, no knowledge or information possessed by any Applicant shall be imputed to any other Applicants. If any person or persons knew as of the policy inception date that such information contained in the Application(s) was untrue, inaccurate or incomplete, then coverage may be denied or canceled if such information was material to issuance of the policy. However, if the Chairperson of the Board of Directors, President, Chief Executive Officer, or Executive Director of the Applicant knew as of the policy inception date that such information contained in the Application(s) was untrue, inaccurate or incomplete, then coverage may be denied or canceled if such information was material to issuance of the policy;
              </li>
              <li>
                <i class="fas fa-check"></i>
                Statements in the Application, facts pertaining to or knowledge possessed by the individual signing the Application shall be imputed to the Applicant; and
              </li>
              <li>
                <i class="fas fa-check"></i>
                The signing of this Application does not bind the undersigned to purchase insurance.
              </li>
            </ul>
            <p class="input-info notice-info">
              <i class="table-info-fa legalese-fa fas fa-info-circle"></i>
              <span>This Application must be signed by a representative of the Applicant acting as the authorized representative of the person(s) and entity(ies) proposed for this insurance.</span>
            </p>
            <article class="input-section form-heading form-section review-sign">
              <p class="mt-4">
                <strong>Consent to Electronic Signature: </strong>
                I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
              </p>
              <div class="row mr-0 ml-0">
                <div class="col-md-6">
                  <section class="notice-form">
                    <p class="notice-form-date">Date:</p>
                    <input
                      type="date"
                      class="orep-text-input notice-input"
                      placeholder="Enter the Date"
                      id="applicantPrincipleEsignatureDatetime"
                      name="applicantPrincipleEsignatureDatetime"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                    <span
                      v-show="errors.has('applicantPrincipleEsignatureDatetime')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('applicantPrincipleEsignatureDatetime') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form">
                    <p class="notice-form-date">Signature/Title:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Applicant/Principal"
                      name="applicantPrincipleEsignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="quote.applicantPrincipleEsignature"
                    >
                    <span
                      v-show="errors.has('applicantPrincipleEsignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('applicantPrincipleEsignature') | filterText }}</span>
                  </section>
                </div>
              </div>
            </article>
          </form>
          <div class="text-uppercase text-center" style="font-size: 24px; font-weight: bold; margin: 15px 0;">
            Scroll down to submit
          </div>
          <section class="state-law">
            <p  align="justify">
              <strong><u>ALABAMA, ARKANSAS, DISTRICT OF COLUMBIA, LOUISIANA, RHODE ISLAND, WEST VIRGINIA APPLICANTS:</u> ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN PRISON.
              </strong>
            </p>
            <p align="justify">
              <strong><u>CALIFORNIA APPLICANTS: FOR YOUR PROTECTION CALIFORNIA LAW REQUIRES THE FOLLOWING TO APPEAR ON THIS FORM:</u> ANY PERSON WHO KNOWINGLY PRESENTS FALSE OR FRAUDULENT INFORMATION TO OBTAIN OR AMEND INSURANCE COVERAGE OR TO MAKE A CLAIM FOR THE PAYMENT OF A LOSS IS GUILTY OF A CRIME AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN STATE PRISON.</strong>

            </p>
            <p align="justify">
              <strong><u>COLORADO APPLICANTS:</u> IT IS UNLAWFUL TO KNOWINGLY PROVIDE FALSE, INCOMPLETE, OR MISLEADING FACTS OR INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF DEFRAUDING OR ATTEMPTING TO DEFRAUD THE COMPANY. PENALTIES MAY INCLUDE IMPRISONMENT, FINES, DENIAL OF INSURANCE AND CIVIL DAMAGES. ANY INSURANCE COMPANY OR AGENT OF AN INSURANCE COMPANY WHO KNOWINGLY PROVIDES FALSE, INCOMPLETE, OR MISLEADING FACTS OR INFORMATION TO A POLICYHOLDER OR CLAIMANT FOR THE PURPOSE OF DEFRAUDING OR ATTEMPTING TO DEFRAUD THE POLICYHOLDER OR CLAIMANT WITH REGARD TO A SETTLEMENT OR AWARD PAYABLE FOR INSURANCE PROCEEDS SHALL BE REPORTED TO THE COLORADO DIVISION OF INSURANCE WITHIN THE DEPARTMENT OF REGULATORY AGENCIES.</strong>

            </p>
            <p align="justify">
              <strong><u>FLORIDA APPLICANTS:</u> ANY PERSON WHO KNOWINGLY AND WITH INTENT TO INJURE, DEFRAUD, OR DECEIVE ANY INSURER FILES A STATEMENT OF CLAIM CONTAINING ANY FALSE, INCOMPLETE, OR MISLEADING INFORMATION IS GUILTY OF A FELONY OF THE THIRD DEGREE.</strong>
            </p>
            <p align="justify">
              <strong><u>KANSAS APPLICANTS:</u> ANY PERSON WHO, KNOWINGLY AND WITH INTENT TO DEFRAUD, PRESENTS, CAUSES TO BE PRESENTED OR PREPARES WITH KNOWLEDGE OR BELIEF THAT IT WILL BE PRESENTED TO OR BY AN INSURER, PURPORTED INSURER, BROKER OR ANY AGENT THEREOF, ANY WRITTEN, ELECTRONIC, ELECTRONIC IMPULSE, FACSIMILE, MAGNETIC, ORAL, OR TELEPHONIC COMMUNICATION OR STATEMENT AS PART OF, OR IN SUPPORT OF, AN APPLICATION FOR THE ISSUANCE OF, OR THE RATING OF AN INSURANCE POLICY FOR PERSONAL OR COMMERCIAL INSURANCE, OR A CLAIM FOR PAYMENT OR OTHER BENEFIT PURSUANT TO AN INSURANCE POLICY FOR COMMERCIAL OR PERSONAL INSURANCE WHICH SUCH PERSON KNOWS TO CONTAIN MATERIALLY FALSE INFORMATION CONCERNING ANY FACT MATERIAL THERETO; OR CONCEALS, FOR THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO, COMMITS A FRAUDULENT INSURANCE ACT AND MAY BE SUBJECT TO CRIMINAL AND/OR CIVIL FINES OR PENALTIES.</strong>
            </p>
            <p align="justify">
              <strong><u>KENTUCKY APPLICANTS:</u> ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON FILES AN APPLICATION FOR INSURANCE CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS, FOR THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A CRIME.
              </strong>
            </p>
            <p align="justify">
              <strong><u>MAINE, TENNESSEE, VIRGINIA, WASHINGTON APPLICANTS:</u> IT IS A CRIME TO KNOWINGLY PROVIDE FALSE, INCOMPLETE OR MISLEADING INFORMATION TO AN INSURANCE COMPANY FOR THE PURPOSE OF DEFRAUDING THE COMPANY. PENALTIES INCLUDE IMPRISONMENT, FINES AND DENIAL OF INSURANCE BENEFITS.
              </strong>
            </p>
            <p align="justify">
              <strong><u>MARYLAND APPLICANTS:</u> ANY PERSON WHO KNOWINGLY OR WILLFULLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR PAYMENT OF A LOSS OR BENEFIT OR WHO KNOWINGLY OR WILLFULLY PRESENTS FALSE INFORMATION IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN PRISON.
              </strong>
            </p>
            <p align="justify">
              <strong><u>NEW JERSEY APPLICANTS:</u> ANY PERSON WHO INCLUDES ANY FALSE OR MISLEADING INFORMATION ON AN APPLICATION FOR AN INSURANCE POLICY IS SUBJECT TO CRIMINAL AND CIVIL PENALTIES.
              </strong>
            </p>
            <p align="justify">
              <strong><u>NEW MEXICO APPLICANTS:</u> ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR PAYMENT OF A LOSS OR BENEFIT OR KNOWINGLY PRESENTS FALSE INFORMATION IN AN APPLICATION FOR INSURANCE IS GUILTY OF A CRIME AND MAY BE SUBJECT TO CIVIL FINES AND CRIMINAL PENALTIES.
              </strong>
            </p>
            <p align="justify">
              <strong><u>OHIO APPLICANTS:</u> ANY PERSON WHO, WITH INTENT TO DEFRAUD OR KNOWING THAT HE IS FACILITATING A FRAUD AGAINST AN INSURER, SUBMITS AN APPLICATION OR FILES A CLAIM CONTAINING A FALSE OR DECEPTIVE STATEMENT IS GUILTY OF INSURANCE FRAUD.
              </strong>
            </p>
            <p align="justify">
              <strong><u>OKLAHOMA APPLICANTS:</u> WARNING: ANY PERSON WHO KNOWINGLY, AND WITH INTENT TO INJURE, DEFRAUD OR DECEIVE ANY INSURER MAKES ANY CLAIM FOR THE PROCEEDS OF AN INSURANCE POLICY CONTAINING ANY FALSE, INCOMPLETE OR MISLEADING INFORMATION IS GUILTY OF A FELONY.
              </strong>
            </p>
            <p align="justify">
              <strong><u>OREGON APPLICANTS:</u> ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON FILES AN APPLICATION FOR INSURANCE CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS, FOR THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO MAY BE COMMITTING A FRAUDULENT INSURANCE ACT, WHICH MAY BE A CRIME AND MAY SUBJECT THE PERSON TO PENALTIES.
              </strong>
            </p>
            <p align="justify">
              <strong><u>PENNSYLVANIA APPLICANTS:</u> ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON FILES AN APPLICATION FOR INSURANCE OR STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS FOR THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A CRIME AND SUBJECTS SUCH PERSON TO CRIMINAL AND CIVIL PENALTIES.
              </strong>
            </p>
            <p align="justify">
              <strong><u>VERMONT APPLICANTS:</u> ANY PERSON WHO KNOWINGLY PRESENTS A FALSE STATEMENT IN AN APPLICATION FOR INSURANCE MAY BE GUILTY OF A CRIMINAL OFFENSE AND SUBJECT TO PENALTIES UNDER STATE LAW.
              </strong>
            </p>
<!--            <p>-->
<!--              <strong>NOTICE TO PENNSYLVANIA APPLICANTS:</strong> Any person who knowingly and with intent to defraud any insurance company or other-->
<!--              person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of-->
<!--              misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such-->
<!--              person to criminal and civil penalties.-->
<!--            </p>-->
<!--            <p>-->
<!--              <strong>NOTICE TO VERMONT APPLICANTS:</strong> Any person who knowingly presents a false statement in an application for insurance may be-->
<!--              guilty of a criminal offense and subject to penalties under state law.-->
<!--            </p>-->
          </section>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'property-inspector-3'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('property-inspector-3')"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" :disabled="!state.pageFourIsValid" @click="next('property-inspector-5')" v-if="!state.signedInUser"></button>
              <button class="pagination-dots" :disabled="!state.pageFourIsValid" @click="next('property-inspector-6')"></button>
              <button class="pagination-dots" :disabled="!state.pageFourIsValid || !state.pageSixIsValid" @click="next('property-inspector-7')"               v-if="quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' && (checkServices('real estate agent') || checkServices('contractor') || checkServices('engineer') || checkServices('pest inspector'))"
              ></button>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              @click="nextpage()"
              :disabled="!state.pageFourIsValid"
              :class="{submitDisabled: !state.pageFourIsValid}"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';

export default {
  name: "property-inspector-4",
  computed: {
    quote() {
      return this.$store.state.homeInspector.quote;
    },
    state() {
      return this.$store.state.homeInspector;
    },
    errorMsg() {
      return this.$store.state.homeInspector.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },
    checkServices(service) {
      return this.quote.applicantOrAssociateReportMode.includes(service);
    },
    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    nextpage() {
      // eslint-disable-next-line eqeqeq
      if (!this.state.signedInUser){
        this.$router.push({
          name: 'property-inspector-5'
        });
      } else {
        this.$router.push({
          name: 'property-inspector-6'
        });
      }
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.quote.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
    }
  },


  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.orep-header').offset().top
    }, 500);
  },

  components: {}
};
</script>

<style scoped>
  .form-errors {
    display: block;
    text-transform: initial;
    font-size: 13px;
    width: 90%;
    margin: auto;
    position: relative;
    top: -29px;
  }
  fieldset {
    font-size: 12px;
  }
  h6 {
    font-size: 14px;
  }
  h5 {
    font-size: 16px;
  }
  .table th, .table td {
    text-align: center;
    vertical-align: middle;
  }
  .table.ar td, .table.ar th {
    border-left: 1px solid #ddd !important;
    border-top: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
  }
  .page-content p, .page-content li {
    font-size: 15px;
  }
  .p-56, .notice-list > li, .notice-info {
    padding-right: 56px;
  }
</style>

